import axios from 'axios';
import { Constants } from '../models/Constants';

export interface IConfigurationValuesService {
    readonly applicationName: string;
    readonly piwikUrl: string;
    readonly piwikTrackingId: number;
    readonly version: string;
    readonly apiUrl: string;
    readonly preferredLocale: string;
    readonly showCustomTranslatorTemplate: boolean;
    readonly preferredLogoUrl: string;
    readonly supportUrl: string;
    readonly privacyPolicyUrl: string;
    initAsync(): Promise<boolean>;
}

export default class ConfigurationValuesService implements IConfigurationValuesService {
    static serviceInstance: IConfigurationValuesService | undefined;
    private values: {
        [key: string]: string | number | boolean;
    };

    static getInstance() {
        if (this.serviceInstance === undefined) {
            this.serviceInstance = new ConfigurationValuesService();
        }
        return this.serviceInstance;
    }

    static removeInstance() {
        this.serviceInstance = undefined;
    }

    constructor() {
        this.values = {};
     }

     async initAsync(): Promise<boolean> {
        try {
            const response = await axios.get('static/data/static-configuration.json', {});
            this.values = response.data.constants;
            return true;
        } catch (e) {
            return false;
        }
     }

    get applicationName(): string {
        return this.values[Constants.applicationName] as string;
    }

    get piwikUrl(): string {
        return this.values[Constants.piwikUrl] as string;
    }

    get piwikTrackingId(): number {
        return this.values[Constants.piwikTrackingId] as number;
    }

    get version(): string {
        return this.values[Constants.version] as string;
    }

    get apiUrl(): string {
        return this.values[Constants.apiUrl] as string;
    }

    get preferredLocale(): string {
        return this.values[Constants.preferredLocale] as string;
    }
    get showCustomTranslatorTemplate(): boolean {
        return this.values[Constants.showCustomTranslatorTemplate] as boolean;
    }

    /**
     * Optional config workaround to add custom logo branding
     */
    get preferredLogoUrl(): string {
        return this.values[Constants.preferredLogoUrl] as string;
    }

    /**
     * Optional config workaround to add custom support url
     */
    get supportUrl(): string {
        return this.values[Constants.supportUrl] as string;
    }

    /**
     * Optional config workaround to add custom privacy policy url
     */
    get privacyPolicyUrl(): string {
        return this.values[Constants.privacyPolicyUrl] as string;
    }
}



// WEBPACK FOOTER //
// ./src/services/ConfigurationValuesService.ts